export default __webpack_public_path__ + "static/services-details1-98fb15455f700c2c9aae9ae16d910faf.png";